import React, { useCallback, useEffect, useState } from 'react';
import QRScanner from './BookingQrScanner';
import axios from 'axios';

const BookingQRRead = (props) => {
  const { user, setting } = props;
  const [message, setMessage] = useState('');
  const [scanning, setScanning] = useState(true);
  const [showCompletion, setShowCompletion] = useState(false);

  useEffect(() => {
    if (showCompletion) {
      const timer = setTimeout(() => {
        setShowCompletion(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showCompletion]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const setQrCodeData = useCallback(async (qrData) => {
    if (!qrData) {
      return;
    }

    const jwt = localStorage.getItem('jwt');
    const siteId = props.match.params.siteId;

    try {
      const booking_data = (await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/booking/qr/${siteId}`,
        { qr_data: qrData },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      )).data;

      if (booking_data) {
        const param = {
          book_id: booking_data.book_id,
          line_id: booking_data.line_id,
          customer_id: booking_data.customer_id,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/booking/status/update/${siteId}`,
          param,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );

        if (response && response.status === 200) {
          setShowCompletion(true);
        } else {
          setMessage('チェックインに失敗しました');
        }
      }
    } catch (err) {
      console.log(err);
      setMessage('不正なQRコードが読み込まれました');
    }
    setScanning(true);
  }, [props.match.params.siteId, user, setting]);

  return (
    <div className="container-fluid">
      <React.Fragment>
        <div className="vertical">
          <QRScanner {...props} setQrCodeData={setQrCodeData} message={message} scanning={scanning} />

          <div className="row">
            <div className="col text-center mt-2">
              <span>QRコードをスキャンしてください</span>
            </div>
          </div>

          <div className="row">
            <div className="col text-center mt-2">
              <span>カメラが表示されない場合は、画面を更新してください</span>
            </div>
          </div>
          {message && (
            <div className="row">
              <div className="col text-center mt-2">
                <span className="h2 text-danger font-weight-bold">{message}</span>
              </div>
            </div>
          )}

          {showCompletion && (
            <div className="row">
              <div className="col text-center mt-2">
                <span className="h2 text-success font-weight-bold">チェックインが完了しました</span>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    </div>
  );
}
export default BookingQRRead;
